import { CompositeInput } from '@pba/react-components';
import type { RequiredGeneric } from '@pba/utils';
import { Form } from 'ui';
import { useChatInputAttachments } from './hooks';

export type ChatInputAttachment = {
  contentType: string;
  fileId?: string;
  filename: string;
  id: string;
  isLoading?: boolean;
  url?: string;
};

export type ChatInputFormValues = {
  attachments: ChatInputAttachment[];
  message?: string;
};

type P = {
  isVisible?: boolean;
};

const ChatInput = <T extends ChatInputFormValues = never>({ isVisible = true }: RequiredGeneric<T, P>) => {
  const { attachments, handleRemoveAttachment, handleSelectFiles } = useChatInputAttachments();

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <Form.Item<ChatInputFormValues> name="attachments" noStyle />
      <Form.Item<ChatInputFormValues> name="message" noStyle>
        <CompositeInput
          attachments={attachments}
          onRemoveAttachment={handleRemoveAttachment}
          onSelectFiles={handleSelectFiles}
          placeholder="Send a message ..."
        />
      </Form.Item>
    </>
  );
};

export default ChatInput;
